/**
 * SidebarSearch — filter the sidebar tree live by slug/label match.
 * Forwards ref so the parent Sidebar can focus via `/` keybinding.
 */
import { forwardRef } from "react";
import { Search } from "./icons";

export interface SidebarSearchProps {
	query: string;
	onChange: (q: string) => void;
	placeholder?: string;
}

export const SidebarSearch = forwardRef<HTMLInputElement, SidebarSearchProps>(
	function SidebarSearch(
		{ query, onChange, placeholder = "Search features..." },
		ref,
	) {
		return (
			<div className="flex items-center gap-2 bg-zinc-50 border border-zinc-200 rounded-md px-2.5 py-1.5 text-[13px]">
				<Search className="w-4 h-4 text-zinc-400 shrink-0" />
				<input
					ref={ref}
					type="text"
					value={query}
					onChange={(e) => onChange(e.target.value)}
					placeholder={placeholder}
					aria-label="Search sidebar"
					className="flex-1 bg-transparent outline-none placeholder:text-zinc-400 text-zinc-900 min-w-0"
				/>
				{query ? (
					<button
						type="button"
						onClick={() => onChange("")}
						className="text-[10px] text-zinc-400 hover:text-zinc-700"
						aria-label="Clear search"
					>
						Clear
					</button>
				) : (
					<kbd className="text-[10px] font-medium text-zinc-400 bg-white border border-zinc-200 rounded px-1 py-0.5">
						/
					</kbd>
				)}
			</div>
		);
	},
);
